import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from "react-progressive-image";
import assets from "../../../../../../util/assets";
import "./index.css";

SubscriberListItem.propTypes = {
    item: PropTypes.object.isRequired,
};

function SubscriberListItem(props) {
    return (
        <div className="subscriber-list-container">
            <div className="display-flex-align-center">
                <ProgressiveImage
                    delay={1000}
                    src={props.item.profile_pic}
                    placeholder="placeholder">

                    {(src, loading) => {
                        return loading ? (
                                <img alt="broadcaster profile picture"
                                     className="subscriber-list-container-user-section-profile-pic"
                                     src={assets.user_placeholder}/>
                            ) :
                            (
                                <div
                                    className="subscriber-list-container-user-section-profile-pic"
                                    style={{backgroundImage: "url('" + props.item.profile_pic + "')"}}>

                                </div>
                            )

                    }}
                </ProgressiveImage>
                <div className="subscriber-list-container-column2">
                    <div className="subscriber-list-container-broadcaster-name">
                        <span>{props.item.username}</span>
                    </div>
                    <div
                        className="subscriber-list-container-billing-text">{props.item.subscription.data.status}</div>
                    <div className="subscriber-list-container-amount-formatted">
                        {props.item.subscription.data.amount_formatted}
                    </div>
                </div>
            </div>

        </div>
    );
}

export default SubscriberListItem;